import {Inject, Injectable} from '@angular/core';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../config/hotel-tours-list-page.config";

@Injectable({
  providedIn: 'root',
})
export class HotelTourCalendarNightsService {
  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
  ) {
  }

  getNights(nightsFrom: number): { nightsFrom: number; nightsTo: number } {
    // Первая строка на день короче поиска, но не меньше 3 дней (2 ночей).
    const firstNights = Math.max(2, nightsFrom - 1);
    return { nightsFrom: firstNights, nightsTo: firstNights + 6 };
  }
}
